// cfgmenus

const mutations = {
	getCfgMenus(state, objects) {
		state.cfgmenus = objects;
  	},

};

export default mutations;